import classes from "./VideoHero.module.css";
import ReactPlayer from "react-player";
import backgroundVideo from "../../media/acctvtrailer2.mp4";
import thumbnail from "../../media/acctv_thumb.gif";

export function VideoHero() {
  return (
    <div className={classes.videoContainer}>
      <ReactPlayer
        className={classes.videoPlayer}
        height={"100%"}
        width={"100%"}
        light={<img src={thumbnail} alt='Thumbnail' />}
        controls={true}
        url={backgroundVideo}
        playing={true}
        loop={false}
        muted={false}
        config={{
          file: {
            attributes: {
              style: { objectFit: "cover", height: "100%" },
            },
          },
        }}
      />
    </div>
  );
}
